import { Grid2 } from "@mui/material";
import React, { useState } from "react";
import CandidatePerspective from "../../../candidates/candidate-perspective";
import CommonAccordion from "../../../common-components/CommonAccordion";
import AddUpdateNote from "../jobs-candidate/components/CreateNote";
import Interactions from "../jobs-summary/components/Interactions";
import Experience from "./components/Experience";
import MatchingSummary from "./components/MatchingSummary";
import Notes from "./components/Notes";
import Profile from "./components/Profile";
import Recommendations from "./components/Recommendations";
import StrengthWeak from "./components/StrengthWeak";
import { useLocation, useNavigate } from "react-router-dom";
import Comparison from "./components/Comparison";
import DeleteNote from "./components/DeleteNote";
import SnackBar from "../../../../component/SnackBar";

function JobsCandidate({ matchedData, resumeId, candidate }) {
  const navigate = useNavigate();
  const [noteList, setNoteList] = useState([
    { note: "", interaction: "Email", added_by: "username", title: "Notes" },
  ]);
  const [openNoteDialog, setOpenNoteDialog] = useState(false);
  const [deleteNoteDialogOpen, setDeleteNoteDialogOpen] = useState(false);
  const [noteId, setNoteId] = useState("");
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [notesTableList, setNotesTableList] = useState([
    {
      id: 1767809208522,
      note: "zcsz",
      interaction: "Email",
      added_by: "username",
      title: "Notes",
      created_at: "2026-01-07T18:06:47.520Z",
    },
  ]);
  const [addNoteLoading, setAddNoteLoading] = useState(false);
  const [notesTableListLoading, setNotesTableListLoading] = useState(false);
  const [isCandidatePerspectiveOpen, setIsCandidatePerspectiveOpen] =
    useState(false);
  const handleChangeRequestInfo = () => {
    // setIsCandidatePerspectiveOpen(true);
    navigate("/candidate-perspective");
  };
  const handleClickAddNote = () => {
    setNoteId("");
    setOpenNoteDialog(true);
  };

  const handleCloseNoteDialog = () => {
    setNoteId("");
    setOpenNoteDialog(false);
    setNoteList([
      { note: "", interaction: "Email", added_by: "username", title: "Notes" },
    ]);
  };

  const handleDeleteNote = (row, index) => {
    setDeleteNoteDialogOpen(true);
    setNoteId(index);
    setNoteList([
      {
        id: index,
        note: row?.note,
        interaction: row?.interaction,
        added_by: row?.added_by,
        created_at: row?.created_at,
        title: "Notes",
      },
    ]);
  };

  const handleDeleteNoteDialogClose = () => {
    setDeleteNoteDialogOpen(false);
    setNoteId("");
    setNoteList([
      { note: "", interaction: "Email", added_by: "username", title: "Notes" },
    ]);
  };

  const handleUpdateNote = (row, index) => {
    setNoteId(index);
    setOpenNoteDialog(true);
    setNoteList([
      {
        id: index,
        note: row?.note,
        interaction: row?.interaction,
        added_by: row?.added_by,
        title: "Notes",
      },
    ]);
  };

  console.log(noteId, notesTableList, "sflsnfsjnfsjfhjn");

  const handleCreateNote = async () => {
    setAddNoteLoading(true);
    setNotesTableListLoading(true);
    const payload = { ...noteList[0], created_at: new Date().toISOString() };
    setTimeout(() => {
      setNotesTableList((prevList) => {
        if (noteId !== "" && noteId >= 0) {
          console.log(prevList, "prevListprevList");
          return prevList.map((note, index) =>
            index === noteId ? { ...payload } : note
          );
        } else {
          console.log("sfjkfjksnfsjkjn");
          return [
            ...prevList,
            {
              id: new Date().getTime(),
              ...payload,
            },
          ];
        }
      });

      setAddNoteLoading(false);
      setOpenNoteDialog(false);
      setNoteList([
        {
          note: "",
          interaction: "Email",
          added_by: "username",
          title: "Notes",
        },
      ]);
      setNotesTableListLoading(false);
    }, 1000);
  };

  const handleDeleteNoteById = async (row) => {
    setNotesTableListLoading(true);
    setTimeout(() => {
      setNotesTableList((prevList) => {
        return prevList.filter((note, index) => index !== noteId);
      });

      setSnackbarState({
        open: true,
        severity: "success",
        message: "Note deleted successfully",
      });

      setNoteList([
        {
          note: "",
          interaction: "Email",
          added_by: "username",
          title: "Notes",
        },
      ]);
      setDeleteNoteDialogOpen(false);
      setNoteId("");
      setNotesTableListLoading(false);
    }, 1000);
  };

  const handleNoteTextChange = (index, e) => {
    const newNoteList = [...noteList];
    newNoteList[index].note = e.target.value;
    setNoteList(newNoteList);
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const { pathname } = useLocation();

  return (
    <>
      <Grid2 container spacing={4}>
        {!isCandidatePerspectiveOpen && (
          <Grid2 size={12}>
            <Profile
              matchedData={matchedData}
              resumeId={resumeId}
              handleChangeRequestInfo={handleChangeRequestInfo}
              handleClickAddNote={handleClickAddNote}
            />
          </Grid2>
        )}
        {isCandidatePerspectiveOpen && <CandidatePerspective />}
        {!isCandidatePerspectiveOpen && (
          <Grid2 size={12}>
            <CommonAccordion
              title={"Matching Summary"}
              children={<MatchingSummary matchedData={matchedData} />}
            />
          </Grid2>
        )}
        {!isCandidatePerspectiveOpen && (
          <Grid2 size={12}>
            <CommonAccordion
              title={"Comparison"}
              children={
                <>
                  {pathname && !pathname.includes("/compare") && (
                    <Grid2 item size={12}>
                      <Comparison />
                    </Grid2>
                  )}{" "}
                </>
              }
            />
          </Grid2>
        )}
        {!isCandidatePerspectiveOpen && (
          <Grid2 size={12}>
            <CommonAccordion
              title={"Strengths and Weaknesses"}
              children={<StrengthWeak size={6} matchedData={matchedData} />}
            />
          </Grid2>
        )}
        {!isCandidatePerspectiveOpen && (
          <Grid2 size={12}>
            <CommonAccordion
              title={"Interview/Assessments and Info Collection:"}
              children={<Recommendations />}
            />
          </Grid2>
        )}
        {!isCandidatePerspectiveOpen && (
          <Grid2 size={12}>
            <CommonAccordion
              title={"Experience"}
              children={<Experience matchedData={matchedData?.experience} />}
            />
          </Grid2>
        )}

        {!isCandidatePerspectiveOpen && (
          <Grid2 size={12}>
            <CommonAccordion title={"Notes"}>
              <Notes
                isShown={true}
                handleClickAddNote={handleClickAddNote}
                handleDeleteNoteClick={handleDeleteNote}
                handleUpdateNoteClick={handleUpdateNote}
                notesTableList={notesTableList}
                notesTableListLoading={notesTableListLoading}
              />
            </CommonAccordion>
          </Grid2>
        )}
        {!isCandidatePerspectiveOpen && (
          <Grid2 size={12}>
            <CommonAccordion
              title={"Interactions"}
              children={<Interactions />}
            />
          </Grid2>
        )}

        <AddUpdateNote
          openNoteDialog={openNoteDialog}
          handleCloseNoteDialog={handleCloseNoteDialog}
          id={noteId}
          handleCreateNote={handleCreateNote}
          noteList={noteList}
          handleNoteTextChange={handleNoteTextChange}
          addNoteLoading={addNoteLoading}
        />

        <DeleteNote
          deleteNoteDialogOpen={deleteNoteDialogOpen}
          handleDeleteNoteDialogClose={handleDeleteNoteDialogClose}
          noteList={noteList}
          handleDeleteNoteById={handleDeleteNoteById}
        />

        <SnackBar
          snackbarState={snackbarState}
          handleCloseValidation={handleCloseValidation}
        />
      </Grid2>
    </>
  );
}

export default JobsCandidate;
